import { SettingsCache } from "../cache/SettingsCache";
import { FormFieldComponentProps } from "../components/new_form/form_fields/FormFieldComponent";
import { getEventMetadata } from "../helper";

export function getNewInputElementFormFields(
  nameField: string,
): FormFieldComponentProps[] {
  return [
    {
      type: "text",
      key: "name",
      label: nameField,
      required: true,
      placeholder: "Input",
    },
    {
      type: "hardcoded",
      key: "session",
      value: localStorage.getItem("second-brain-session"),
    },
    {
      type: "hardcoded",
      key: "type",
      value: 1,
    },
    {
      type: "hardcoded",
      key: "minuteEstimate",
      value: 0,
    },
    {
      type: "hardcoded",
      key: "topItemOfDay",
      value: false,
    },
    {
      type: "hardcoded",
      key: "eventMetadata",
      value: getEventMetadata(),
    },
    {
      type: "hardcoded",
      key: "priority",
      value: SettingsCache.getInstance().getDefaultPriority(),
    },
  ];
}
